import { twMerge } from "tailwind-merge";
import { Card, SmallButton } from "@sellar-io/components";
import { useForm, useWatch } from "react-hook-form";
import { useEvents } from "../../../hooks";
import { useOrderCommentCreate } from "../../../hooks/api/v2/orderComment/useOrderCommentCreate";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { useState } from "react";
import { ChatInput } from "../../../components/chatInput/ChatInput";

export const OrderRequestedSendMessage = ({
  orderId,
  onFocus,
  onBlur,
  setTextInputHasContent,
}: {
  orderId: number;
  onFocus?: () => void;
  onBlur?: () => void;
  setTextInputHasContent?: (state: boolean) => void;
}) => {
  const [showButtons, setShowButtons] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useForm({
    defaultValues: {
      message: "",
    },
  });
  const { track } = useEvents();
  const { business } = useSellarCurrentBusiness();
  const mutation = useOrderCommentCreate();
  const message = useWatch({
    control: form.control,
    name: "message",
  });
  const setMessage = (value: string) => {
    form.setValue("message", value);
    setTextInputHasContent?.(Boolean(value));
  };

  const onSubmit = () => {
    if (!message) return;
    setLoading(true);
    mutation.mutate(
      {
        OrderId: orderId,
        message,
      },
      {
        onSuccess: () => {
          setTimeout(() => {
            setLoading(false);
            form.reset();
            setTextInputHasContent?.(false);
            track("Comment Created", {
              businessName: business?.name,
              message,
              kind: "comment",
            });
          }, 1500);
        },
        onError: () => {
          setLoading(false);
        },
      },
    );
  };

  const messageOnFocus = () => {
    setShowButtons(true);
    if (onFocus) onFocus();
  };

  const messageOnBlur = () => {
    setShowButtons(false);
    if (onBlur) onBlur();
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Card className={twMerge("bg-white", "flex flex-col gap-2 p-4")}>
        <ChatInput
          {...form.register("message")}
          value={message}
          setValue={setMessage}
          onFocus={messageOnFocus}
          onBlur={messageOnBlur}
          placeholder="Add a comment"
        />
        {(showButtons || message) && (
          <div className="flex justify-end gap-2">
            <SmallButton
              className={"h-auto"}
              color="transparent"
              disabled={!message || mutation.isPending}
              onClick={() => setMessage("")}
            >
              Discard
            </SmallButton>
            <SmallButton
              className={"h-auto"}
              type={"submit"}
              disabled={!message || mutation.isPending}
              loading={loading}
            >
              Send message
            </SmallButton>
          </div>
        )}
      </Card>
    </form>
  );
};
